import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ProjektStatiServiceModule } from '..';
import { ProjektStatiSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ProjektStatiServiceModule
  ],
  declarations: [ProjektStatiSorterComponent],
  exports: [ProjektStatiSorterComponent],

})
export class ProjektStatiSorterComponentModule { }
